export default __webpack_public_path__ + "static/media/CoronaClosed.dd203e67.jpg";